import React from 'react';
import { FaArrowUp, FaArrowDown } from 'react-icons/fa';

const PerformanceCard = ({ title, value, icon, increase }) => {
    const isPositive = increase >= 0;
    const periodText = 'from last month'; // Hardcode to 'from last month'
    return (
        <div className="bg-gradient-card border border-border/50 hover-lift hover-glow rounded-md p-4">
            <div className="flex items-center justify-between mb-2">
                <h3 className="text-sm text-gray-400">{title}</h3>
                {icon}
            </div>
            <p className="text-2xl font-bold">{value}</p>
            <p className={`${isPositive ? 'text-green-400' : 'text-red-400'} text-sm flex items-center`}>
                {isPositive ? <FaArrowUp className="inline-block mr-1" /> : <FaArrowDown className="inline-block mr-1" />}
                {increase.toFixed(2)}% {periodText}
            </p>
        </div>
    );
};

export default PerformanceCard;